/**
 * Weight formatting for admin views. Storage/API remain in kg; these
 * helpers only format for tons display.
 */

/** "1.5 t" style label; em dash when unknown. */
export function tons(kgValue: number | null | undefined, decimals = 1): string {
  if (kgValue == null) return '—';
  return `${(kgValue / 1000).toFixed(decimals)} t`;
}
